export const SET_SHOW_MODAL = 'SET_SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';
export const SHOW_CALLOUT = 'SHOW_CALLOUT';
export const HIDE_CALLOUT = 'HIDE_CALLOUT';
export const SHOW_ERROR = 'SHOW_ERROR';
export const TOGGLE_MOBILE_NAV = 'TOGGLE_MOBILE_NAV';
export const SET_EDITOR_MODE = 'SET_EDITOR_MODE';
export const UNLOAD_PLAYBACK = 'UNLOAD_PLAYBACK';
export const LOAD_PLAYBACK = 'LOAD_PLAYBACK';
export const SET_UI_STATE = 'SET_UI_STATE';
export const LOADED_PLAYBACK_ASSETS = 'LOADED_PLAYBACK_ASSETS';
export const UI_LOADING = 'UI_LOADING';
export const CURRENT_HOME_VIEW = 'CURRENT_HOME_VIEW';
export const AUDIO_RECORDING_START = 'AUDIO_RECORDING_START';
export const AUDIO_RECORDING_CANCEL = 'AUDIO_RECORDING_CANCEL';
export const SHOW_RECORD_PANEL = 'SHOW_RECORD_PANEL';
export const CURRENT_EDIT_ANIMATION_TAB = 'CURRENT_EDIT_ANIMATION_TAB';

export const EDITOR_MODES = {
  EDIT: 'EDIT',
  IMAGE_CROP: 'IMAGE_CROP',
  default: 'EDIT'
};

export const setShowModal = (modal, value) => ({
  type: SET_SHOW_MODAL,
  modal,
  value
});

export const hideModal = (scribeId, modal) => ({
  type: HIDE_MODAL,
  scribeId,
  modal
});

export const showCallout = callout => ({
  type: SHOW_CALLOUT,
  callout
});

export const hideCallout = () => ({
  type: HIDE_CALLOUT
});

export const showError = error => ({
  type: SHOW_ERROR,
  error
});

export const toggleMobileNav = () => ({
  type: TOGGLE_MOBILE_NAV
});

export const setEditorMode = mode => ({
  type: SET_EDITOR_MODE,
  mode
});

export const unloadPlayback = scribeId => ({
  type: UNLOAD_PLAYBACK,
  scribeId
});

export const loadPlayback = (showLoading = false) => ({
  type: LOAD_PLAYBACK,
  showLoading
});

export const setUIState = uiState => ({
  type: SET_UI_STATE,
  uiState
});

export const loadedPlaybackAssets = () => ({
  type: LOADED_PLAYBACK_ASSETS
});

export const startLoading = () => ({
  type: UI_LOADING,
  isLoading: true
});

export const stopLoading = () => ({
  type: UI_LOADING,
  isLoading: false
});

export const setCurrentHomeView = currentHomeView => ({
  type: CURRENT_HOME_VIEW,
  currentHomeView
});

export const audioRecordingStart = (scribeId, audioType) => ({
  type: AUDIO_RECORDING_START,
  scribeId,
  audioType
});

export const audioRecordingCancel = (scribeId, audioType) => ({
  type: AUDIO_RECORDING_CANCEL,
  scribeId,
  audioType
});

export const showRecordPanel = () => ({
  type: SHOW_RECORD_PANEL
});

export const setCurrentEditAnimationTab = currentEditAnimationTab => ({
  type: CURRENT_EDIT_ANIMATION_TAB,
  currentEditAnimationTab
});
